import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AuthenticatedTemplate, UnauthenticatedTemplate } from '@azure/msal-react';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import './App.scss';
import { setShouldNavigateToChats } from './application/features/common/commonSlice';
import { useAppSelector } from './application/store/useStore';
import MonteurAuthentication from './ui/components/MonteurAuthentication';
import Login from './ui/pages/auth/login';
function App() {
    var dispatch = useDispatch();
    var pathname = useLocation().pathname;
    var navigate = useNavigate();
    var shouldNavigateToChats = useAppSelector(function (state) { return state.common.shouldNavigateToChats; });
    useEffect(function () {
        if (shouldNavigateToChats) {
            if (pathname !== '/chats') {
                navigate('/chats');
            }
            dispatch(setShouldNavigateToChats(false));
        }
    }, [shouldNavigateToChats, navigate, dispatch, pathname]);
    return (_jsxs("div", { style: { width: '100%', backgroundColor: '#FAFDFF', height: '100%' }, children: [_jsx(AuthenticatedTemplate, { children: _jsx(MonteurAuthentication, {}) }), _jsx(UnauthenticatedTemplate, { children: _jsx(Login, {}) })] }));
}
export default App;
